// Option layout for any ORDER combobox (Record Dispatch today; Record Receipt reuses it): line 1 = id + customer, line 2 = Order date + items + what is left.
// Pure: the caller injects the formatters (Settings > Formatting) and the translated words. label (one line) fills the input once chosen; search covers id, customer,
// every item name AND the order-date text (ISO and the formatted form) so a typed date finds the order.
import { unitGroups, groupsText } from '../dispatchUnits.mjs';

export function orderOption(o, { fmtDate, fmtQty, itemsLabel, orderDateLabel, leftLabel }) {
  const items = Number(o.line_count) > 1 ? itemsLabel(o.line_count) : (o.item_name || '—');
  const left = groupsText(unitGroups((o.remaining || []).map(r => ({ qty: r.qty, line: { item_unit: r.unit } })), fmtQty), fmtQty);
  const date = o.op_date ? fmtDate(o.op_date) : '—';
  const line1 = `${o.operation_id} · ${o.customer_name || '—'}`;
  const line2 = `${orderDateLabel} ${date} · ${items}${left && left !== '—' ? ` · ${leftLabel(left)}` : ''}`;
  return { value: o.operation_id, line1, line2, label: `${line1} · ${line2}`, search: [line1, line2, ...(o.item_names || []), o.op_date || ''].join(' ') };
}

// What the server can match for a typed date: the app shows dates day-first (dd/mm/yyyy); the API holds ISO text, so '07/10/2026' -> '2026-10-07', '07/10' -> '-10-07',
// '07' alone stays as typed (it also matches ids). Anything else passes through unchanged.
export function serverSearchTerm(q) {
  const t = String(q || '').trim();
  const m = /^(\d{1,2})[/.-](\d{1,2})(?:[/.-](\d{4}))?$/.exec(t);
  if (!m) return t;
  const [, d, mo, y] = m, two = n => n.padStart(2, '0');
  return `${y ? y + '-' : '-'}${two(mo)}-${two(d)}`;
}
